import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "above", "below", "screen", "print"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import Base from '../Base';
import styles from './index.module.scss';
var Hidden = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _classnames;

  var className = _ref.className,
      above = _ref.above,
      below = _ref.below,
      screen = _ref.screen,
      print = _ref.print,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classnames = (_classnames = {}, _classnames[styles.screen] = !!screen, _classnames[styles.print] = !!print, _classnames[styles.aboveXs] = above === 'xs', _classnames[styles.aboveSm] = above === 'sm', _classnames[styles.aboveMd] = above === 'md', _classnames[styles.aboveLg] = above === 'lg', _classnames[styles.belowSm] = below === 'sm', _classnames[styles.belowMd] = below === 'md', _classnames[styles.belowLg] = below === 'lg', _classnames[styles.belowXl] = below === 'xl', _classnames);
  return /*#__PURE__*/React.createElement(Base, _extends({
    ref: ref,
    className: cx(classnames, className) || undefined
  }, rest));
});
Hidden.displayName = 'Hidden';
Hidden.identifier = Hidden.displayName;
Hidden.clonableProps = [];
Hidden.defaultProps = {};
export default Hidden;